import bindHtml from "./bindHtml.directive";

const bindHtmlModule = angular
  .module("app.directives.bindHtml", [])
  .directive("bindHtml", bindHtml);

export default bindHtmlModule;



// WEBPACK FOOTER //
// ./src/directives/bindHtml/bindHtml.module.js